import { render, staticRenderFns } from "./sales-qualification.vue?vue&type=template&id=508fac10&scoped=true&"
import script from "./sales-qualification.vue?vue&type=script&lang=js&"
export * from "./sales-qualification.vue?vue&type=script&lang=js&"
import style0 from "./sales-qualification.vue?vue&type=style&index=0&id=508fac10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508fac10",
  null
  
)

export default component.exports